import React from 'react';

export default function ESpotContent({ eSpotData }) {
  function populateMarkup() {
    return { __html: eSpotData?.content };
  }
  return (
    <div className="genericESpot" data-espot-key={eSpotData?.key} data-espot-source={eSpotData?.source} dangerouslySetInnerHTML={populateMarkup()} />
  );
}
